import React from 'react';
import './App.css';
import history from './history'
import { Switch, Router, Route } from 'react-router-dom'
import Splash from './Views/Splash'
import About from './ArViews/About';
import Quotes from './Views/Quotes';
import Finance from './Views/Finance';
// import SignIn from './Views/SignIn';
import DashC from './NewArContainers/DashC';
import oldDC from './Containers/DashC';
// import Main from './FutureMe/View/Main';
import PayConfirm from './Views/PayConfirm';
// import Login from './Views/Login';
// import LoginOldUsers from './Views/LoginOldUsers';
import Login from './ArViews/Login'
import LoginViaEmail from './Views/LoginViaEmail';
import ChangePwd from './Views/ChangePwd';
import Faqs from './Views/Faqs';
import CreateAccount from './ArViews/CreateAccount';
import ErrorPageNotFound from './Views/ErrorPageNotFound'
import HelpCenter from './Views/HelpCenter';
import PayEase from './ArViews/PayEase';
// import NewDashboard from './ArViews/NewDashboard';

function App() {
  return (
    
  <Router history={history}>
    <Switch> 
       
      <Route exact path={'/' || '/home'} component={Splash} />
      <Route exact path='/about' component={About} />
      <Route exact path='/iamwealthy-account' component={PayEase} />
      <Route exact path='/help-center' component={HelpCenter} />
      <Route exact path='/quote' component={Quotes} />
      <Route exact path='/finance' component={Finance} />
      <Route exact path='/Iamwealthy-login' component={Login} />
      <Route exact path='/wall/:id' component={oldDC} />
      {/* <Route exact path='/futureme' component={Main} /> */}
      <Route exact path='/confirmPay/:userID' component={PayConfirm} />
      <Route exact path='/login/new' component={CreateAccount} />
      {/* <Route exact path='/Iamwealthy/login/new' component={Login} /> */}
      <Route exact path='/Iamwealthy/emaillogin/:refID' component={LoginViaEmail} />
      <Route exact path='/Iamwealthy/changePassword/:refID/:emailAdd' component={ChangePwd} />
      <Route exact path='/faqs' component={Faqs} />
      <Route exact path='/dashboard' component={DashC} />
      <Route component={ErrorPageNotFound} />
      {/* <Route exact path='/logIn' component={SignIn} /> */}

       

      
        
        
    </Switch>

  </Router>
  );
}

export default App;
